import { listAiConfigurationsKeys, useListAiConfigurationQuery } from '@lokalise/shared'
import {
  isRagProfile,
  type RagProfileConfig,
  type StaticProfileConfig,
} from '@lokalise/translation-api-schemas'
import { useMemo } from 'react'
import { isStaticProfile, isUserCreatedProfile, type UserCreatedProfile } from '../types/tag.ts'
import {
  appHttpClient,
  authenticatedPublicApiHeaderBuilder,
  getTeamIdFromSession,
} from '../utils/api'

export type AiProfiles = {
  staticProfile: StaticProfileConfig | undefined
  predefinedProfile: RagProfileConfig | undefined
  customProfiles: UserCreatedProfile[]
}

export const useFetchAiProfiles = () => {
  const teamId = getTeamIdFromSession()
  const queryKey = useMemo(() => listAiConfigurationsKeys.teamAiConfigurationsKey(teamId), [teamId])

  const { data, ...rest } = useListAiConfigurationQuery(
    appHttpClient,
    authenticatedPublicApiHeaderBuilder,
    {
      queryKey,
      select: (res): AiProfiles => {
        // Exclude any static profile data from rendering - we just show a static card instead
        const baseCardData = res.data?.find(isStaticProfile)
        const cardData = res.data?.filter(isRagProfile)
        // Only one TM entry can exist -- can assume this is unique
        const tmCardData = cardData?.find(({ config }) => config?.rag?.type === 'tm')
        const userCreatedCardData = cardData?.filter(isUserCreatedProfile)

        return {
          staticProfile: baseCardData,
          predefinedProfile: tmCardData,
          customProfiles: userCreatedCardData ?? [],
        }
      },
    },
  )

  return { profiles: data, ...rest }
}
